import { render, staticRenderFns } from "./PrelInfo.vue?vue&type=template&id=fb6cfa70&scoped=true&"
import script from "./PrelInfo.vue?vue&type=script&lang=js&"
export * from "./PrelInfo.vue?vue&type=script&lang=js&"
import style0 from "./PrelInfo.vue?vue&type=style&index=0&id=fb6cfa70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb6cfa70",
  null
  
)

export default component.exports